import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {Container, Card, Button} from "react-bootstrap";
import API from "../../api/api";

function Product() {
    const [productInfo, setProductInfo] = useState(null);
    const [manageLink, setManageLink] = useState("")
    const username = localStorage.getItem("username");
    const password = localStorage.getItem("password");
    const {productId} = useParams();


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    useEffect(() => {
        API.get(`products/${productId}`)
            .then((response) => setProductInfo(response.data))
            .catch((error) => console.error(error));

    }, [productId]);

    useEffect(() => {
        if (!username || !password) {
            return
        }
        API.get(`products/get-manage-link/${productId}`, {
            headers: {
                username: username,
                password: password
            }
        })
            .then((response) => setManageLink(response.data))
            .catch((error) => console.error(error));
    }, [productId]);

    function handleBuy() {
        if (!username || !password) {
            window.location = "/login?redirect_url=" + window.location;
            return;
        }
        API.get(`payments/product/${productId}/buy/url`, {
            headers: {
                username,
                password,
            },
        })
            .then((response) => window.open(response.data, '_blank').focus())
            .catch((error) => console.error(error));
    }
    console.log(manageLink);
    return (
        <div className="bg-gradient-dark text-white min-vh-100 d-flex align-items-center">
            <Container>
                {!productInfo ? (
                    <div className="spinner-border" role="status">
                    </div>
                ) : (
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-6">
                            <Card className="bg-dark text-white shadow border-0 rounded">
                                <Card.Body className="p-4">
                                    <Card.Title as="h1" className="text-center mb-3">
                                        {productInfo.name}
                                    </Card.Title>
                                    <Card.Subtitle as="h4" className="text-center mb-4">
                                        {new Intl.NumberFormat("en-US", {
                                            style: "currency",
                                            currency: "USD",
                                        }).format(productInfo.price.unit_amount / 100)}
                                    </Card.Subtitle>
                                    <div className="d-grid gap-2">
                                        {!manageLink && (<Button onClick={handleBuy} variant="primary" size="lg">
                                            Buy Now
                                        </Button>)}
                                        {manageLink && (
                                            <Button onClick={() => window.open(manageLink, "_blank").focus()}
                                                    variant="primary" size="lg">
                                                Manage Subscription
                                            </Button>
                                        )}
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>
                    </div>
                )}
            </Container>
        </div>
    );
}

export default Product;
